import * as Accordion from "@radix-ui/react-accordion"
import { useEffect, useRef } from "react"

import type { AccordionContentProps } from "./AccordionContent.types"

/**
 * Wrapper for Accordion.Content that fixes a known Radix issue where
 * the accordion height doesn't update when children change dynamically.
 * Uses ResizeObserver to manually update the CSS variable height.
 */
export default function AccordionContent(props: AccordionContentProps) {
    const { children, className } = props

    const innerRef = useRef<HTMLDivElement>(null)
    const contentRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const inner = innerRef.current
        const content = contentRef.current

        if (!inner || !content) {
            return
        }

        const resizeObserver = new ResizeObserver(() => {
            const currentHeight = inner.clientHeight
            content.style.setProperty("--radix-accordion-content-height", `${currentHeight}px`)
        })

        resizeObserver.observe(inner)

        return () => resizeObserver.disconnect()
    }, [])

    return (
        <Accordion.Content ref={contentRef} className={className}>
            <div ref={innerRef}>{children}</div>
        </Accordion.Content>
    )
}
